<template>
  <Head :title="'Insights - ' + page.name" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <nav>
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item"><Link :href="'/insights/' + page.client.url">Insights</Link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ page.name }}</li>
            </ol>
          </nav>
          <div class="view-report p-2 pb-0" id="view-report-page">
            <div class="row mt-3 px-2">
              <div class="col-10 card box-content">
                <div class="card-body">
                  <h1 class="my-3"><em>{{ page.name }}</em> has been deleted.</h1>
                  <p>This can often happen if the analysis was specific to a unique field value within your data, such as channel or giving levels, and that value is no longer present. Or, it may have been removed if the subject of the analysis was not pertinent to your organization.</p>
                  <p>If you feel this deletion was in error, you can <Link :href="'/restore/' + page.client.url + '/' + page.url">click here to restore the page.</Link> You can also <a href="mailto:help@avidai.com">reach out to support</a> to get more details on why the page is missing.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head, Link } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  page: Object
});
</script>

